import { CommonModule } from '@angular/common';
import { Directive, ElementRef, NgModule } from '@angular/core';

@Directive({
  selector: 'input, textarea',
})
export class AutocompleteOffDirective {
  constructor(private elRef: ElementRef) {
    const w: any = window;
    const isChrome = w.chrome;
    if (isChrome) {
      this.elRef.nativeElement.setAttribute('autocomplete', 'off');
      this.elRef.nativeElement.setAttribute('autocorrect', 'off');
      this.elRef.nativeElement.setAttribute('autocapitalize', 'none');
      this.elRef.nativeElement.setAttribute('spellcheck', 'false');
    }
  }
}

@NgModule({
  declarations: [AutocompleteOffDirective],
  imports: [CommonModule],
  exports: [AutocompleteOffDirective],
})
export class AutocompleteOffDirectiveModule {}
